import Vue from 'vue'
import MyLoading from './src/index.vue'

let instance

const Loading = {
  show() {
    if (!instance) {
      instance = new (Vue.extend(MyLoading))({
        el: document.createElement('div'),
      })
    }

    if (instance.isShow) return instance
    instance.isShow = true

    document.body.appendChild(instance.$el)
    return instance
  },

  close() {
    if (instance) {
      instance.isShow = false
    }
  },
}

export default Loading
